import React from 'react';

export function LowerLogo() {
  return (
    <svg
      width={'95'}
      height={'30'}
      viewBox={'0 0 95 30'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        fillRule={'evenodd'}
        clipRule={'evenodd'}
        d={'M30.7822 18.7717C30.7822 20.9924 30.1155 23.1633 28.8663 25.0098C27.6172 26.8563 25.8418 28.2955 23.7647 29.1453C21.6875 29.9952 19.4018 30.2175 17.1967 29.7843C14.9915 29.351 12.966 28.2816 11.3762 26.7113C9.78638 25.141 8.70369 23.1403 8.26506 20.9622C7.82644 18.7841 8.05156 16.5265 8.91196 14.4748C9.77236 12.4231 11.2294 10.6694 13.0988 9.43566C14.9682 8.20188 17.1661 7.54333 19.4144 7.54333C22.4259 7.55437 25.3108 8.7409 27.4403 10.8442C29.5697 12.9476 30.771 15.7971 30.7822 18.7717'}
        fill={'#0064FF'}
      />
      <path
        d={'M66.7231 6.08563C61.6009 6.08563 57.9553 10.2727 57.9553 15.3391V15.4298C57.9553 20.9149 61.8623 24.6832 67.2389 24.6832C68.6223 24.7301 69.9972 24.4514 71.2502 23.8703C72.5032 23.2891 73.5983 22.422 74.4453 21.3405L71.5839 18.7725C71.0417 19.3457 70.3851 19.8017 69.6555 20.1116C68.9258 20.4215 68.1391 20.5786 67.3448 20.5729C66.311 20.6326 65.292 20.3074 64.4889 19.6615C63.6859 19.0155 63.1571 18.0958 63.0069 17.0837L75.2931 17.0837C75.2931 16.658 75.3779 16.1416 75.3779 15.688C75.2931 10.7124 72.6225 6.08563 66.7231 6.08563ZM62.9009 13.9713C63.3389 11.6545 64.6389 10.196 66.7231 10.196C68.8073 10.196 70.1921 11.7382 70.4535 13.9713L62.9009 13.9713Z'}
        fill={'#1D1D23'}
      />
      <path
        d={'M49.2796 17.3128L45.8954 6.34265L41.5574 6.34265L38.258 17.229L35.3896 6.42639L30.2744 6.42639L35.7428 24.4308H40.2504L43.7264 13.4537L47.1106 24.4308H51.6181L57.1713 6.42639L52.1409 6.42639L49.2796 17.3128Z'}
        fill={'#1D1D23'}
      />
      <path
        d={'M5.03036 0L0 0L0 24.3409H5.03036L5.03036 0Z'}
        fill={'#1D1D23'}
      />
      <path
        d={'M83.4173 10.0279V6.42706L78.387 6.42706V24.257H83.4173V17.6484C83.4173 13.3636 85.5015 11.3678 88.8009 11.3678H89.0623V6.0572C86.1091 5.99439 84.4771 7.54359 83.4173 10.0279Z'}
        fill={'#1D1D23'}
      />
      <path
        fillRule={'evenodd'}
        clipRule={'evenodd'}
        d={'M94.5317 2.60549C94.5317 3.78865 93.5623 4.74779 92.3664 4.74779C91.1705 4.74779 90.2011 3.78865 90.2011 2.60549C90.2011 1.42234 91.1705 0.463199 92.3664 0.463199C93.5623 0.463199 94.5317 1.42234 94.5317 2.60549ZM94.9999 2.60549C94.9999 4.04447 93.8208 5.21099 92.3664 5.21099C90.912 5.21099 89.7329 4.04447 89.7329 2.60549C89.7329 1.16652 90.912 0 92.3664 0C93.8208 0 94.9999 1.16652 94.9999 2.60549ZM91.9941 3.82139H91.2562V1.18716H92.5152C92.9222 1.18716 93.2037 1.29253 93.3825 1.47316C93.5384 1.62369 93.6183 1.8269 93.6183 2.08656V2.09409C93.6183 2.49675 93.4015 2.76393 93.0706 2.90317L93.7058 3.82139H92.8537L92.3174 3.02359H91.9941V3.82139ZM91.9941 1.81937V2.45159H92.481C92.732 2.45159 92.8766 2.33117 92.8766 2.13924V2.13172C92.8766 1.92474 92.7244 1.81937 92.4772 1.81937H91.9941Z'}
        fill={'#1D1D23'}
      />
    </svg>
  );
}
